import React from 'react';

function InDevelopment() {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '20px',
        fontWeight: 'bold',
      }}
    >
      Страница в разработке
    </div>
  );
}

export default InDevelopment;
